<style scoped>
.chosen_image {
  border: solid 2px;
  border-color: var(--v-primary-base);
}

.outlined {
  border: thin solid rgba(0, 0, 0, 0.12);
}
</style>

<template>
  <v-card :loading="loading">
    <v-app-bar flat dense color="white">
      <v-spacer />
      <v-btn icon @click="handleClose" :disabled="loading">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-app-bar>

    <v-row no-gutters class="px-6">
      <v-col cols="12" md="5" class="mb-5">
        <v-img contain :src="current_image.url" class="outlined" height="300">
          <template v-slot:placeholder>
            <v-overlay absolute>
              <v-icon>mdi-image-off</v-icon>
            </v-overlay>
          </template>
        </v-img>
        <div class="mt-2">
          <v-avatar
            tile
            size="50"
            v-for="photo in photos"
            :key="photo.id"
            :class="{
              chosen_image: photo.id == current_image.id,
              outlined: photo.id != current_image.id,
              'mr-1': true
            }"
            @click="chooseImage(photo)"
          >
            <v-img :src="photo.url">
              <template v-slot:placeholder>
                <v-overlay absolute>
                  <v-icon>mdi-image-off</v-icon>
                </v-overlay>
              </template>
            </v-img>
          </v-avatar>
        </div>
      </v-col>
      <v-col cols="12" md="7">
        <div :class="{ 'ml-5': $vuetify.breakpoint.mdAndUp }">
          <v-card-title class="px-0 pt-0">{{ product.name }}</v-card-title>
          <v-card-subtitle class="font-weight-light px-0">
            {{ $capitalize($tc("model.marketplace_sold_by")) }} {{ product.store.name }}
            <br />
            <v-chip
              v-if="product.availability_id == 2"
              small
              color="green"
              label
              dark
              outlined
              class="mt-1"
              >{{ $capitalize($tc("model.marketplace_in_stock")) }}</v-chip
            >
            <v-chip class="mt-1" v-else small outlined label
              >{{ $capitalize($tc("model.marketplace_unavailable")) }}</v-chip
            >
            <v-chip
              small
              label
              outlined
              class="mt-1 ml-1"
              :title="$capitalize($tc('model.marketplace_bar_code'))"
            >
              <v-icon small left class="grey--text">mdi-barcode</v-icon>
              {{ product.ean }}</v-chip
            >
            <br />
          </v-card-subtitle>

          <v-card-text class="px-0">
            <span class="title">{{ parseMoney(product.price) }}</span>
          </v-card-text>
        </div>
      </v-col>
    </v-row>
    <v-row no-gutters class="px-6">
      <v-col>
        <div v-if="product.description" class="pb-3">
          <span class="title"> {{ $capitalize($tc("model.marketplace_description")) }} </span>
          <v-card-text>
            {{ product.description }}
          </v-card-text>
        </div>
        <div v-if="product.features && product.features.length > 0">
          <span class="title"> {{ $capitalize($tc("model.marketplace_technical_specifications")) }} </span>
          <v-simple-table class="pt-2">
            <tbody>
              <tr v-for="feature in product.features" :key="feature.id">
                <td>{{ feature.name }}</td>
                <td>{{ feature.pivot && feature.pivot.value }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { show as showProduct } from "@/services/products/products";
import money_tool from "@/tools/money";

export default {
  name: "marketplace-product-detail",
  props: ["id"],
  data: () => ({
    product: {
      store: {},
      availability: {},
      price: 0
    },
    current_image: {},
    loading: false
  }),
  methods: {
    resetProduct() {
      this.product = {
        store: {},
        availability: {},
        price: 0
      };
      this.current_image = {};
    },
    handleClose() {
      this.$emit("close");
      this.resetProduct();
    },
    chooseImage(image) {
      this.current_image = image;
    },
    parseMoney(text) {
      return money_tool.euro(text);
    },
    async getProduct() {
      this.loading = true;
      try {
        const response = await showProduct(this.id);

        this.product = {
          ...this.product,
          ...response
        };

        this.current_image = response?.product_photos[0];
      } catch (e) {
        this.$store.commit("sendMessage", {
          text: e.response.data.message,
          color: "red"
        });
      } finally {
        this.loading = false;
      }
    }
  },
  computed: {
    photos: function() {
      if (this.product?.product_photos)
        return this.product.product_photos.slice(0, 5);

      return [];
    }
  },
  created() {
    this.getProduct();
  },
  watch: {
    id: function(value) {
      this.resetProduct();

      if (value) {
        this.getProduct();
      }
    }
  }
};
</script>
